import { AxiosRequestConfig } from 'axios';

import api from 'services/api';

import { getMockCustomerStatusSummary } from 'utils/blockingDevMock';

import { getAccessToken } from './accessTokenServices';

export type FiscalStatus = 'ATIVA' | 'SUSPENSA' | 'INAPTA' | 'BAIXADA' | 'NULA';

export type StateRegistration = {
  serasa?: string[];
  salesforce?: string;
  match?: boolean;
};

export type CustomerStatusSummary = {
  fiscal?: {
    status: FiscalStatus;
    regular: boolean;
  };
  registration?: {
    stateRegistration?: StateRegistration;
    taxpayerClass?: string;
  };
  paymentTerm?: string;
  financial?: {
    hasOverdueBankSlips: boolean;
    overdueCount?: number;
  };
};

export type CustomerStatusFailure =
  | 'unauthorized'
  | 'not-found'
  | 'bad-request'
  | 'network';

export type CustomerStatusResult =
  | { ok: true; data: CustomerStatusSummary }
  | { ok: false; reason: CustomerStatusFailure };

const STATUS_SUMMARY_URL = 'industrial/customer/v1/customers/status-summary';

type ErrorWithResponse = { response?: { status?: number } };

const failureFromStatus = (status?: number): CustomerStatusFailure => {
  if (status === 401) return 'unauthorized';
  if (status === 404) return 'not-found';
  if (status === 400) return 'bad-request';
  return 'network';
};

export const getCustomerStatusSummary = async (
  siteCode: string
): Promise<CustomerStatusResult> => {
  if (!siteCode) {
    return { ok: false, reason: 'bad-request' };
  }

  const mocked = getMockCustomerStatusSummary();
  if (mocked !== undefined) {
    return mocked === null
      ? { ok: false, reason: 'network' }
      : { ok: true, data: mocked };
  }

  const access_token = await getAccessToken();

  const parameters = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      access_token,
    },
    params: { 'site-code': siteCode },
  } as AxiosRequestConfig;

  try {
    const response = await api.get<CustomerStatusSummary>(
      STATUS_SUMMARY_URL,
      parameters
    );

    return { ok: true, data: response.data ?? {} };
  } catch (error) {
    const status = (error as ErrorWithResponse)?.response?.status;
    return { ok: false, reason: failureFromStatus(status) };
  }
};

export default getCustomerStatusSummary;
